import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { InlineEditCellDirective } from '../inline-edit-cell'
import StringUtils from '../../../../../../utils/string.utils'

@Component({
  selector: 'jml-lib-currency-cell',
  templateUrl: './currency-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class CurrencyCellComponent extends InlineEditCellDirective implements OnChanges {
  @Input() currency: string

  repr: string

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.rowData && changes.rowData.currentValue) {
      this.updateRepresentation()
    }
    super.ngOnChanges(changes)
  }

  abortCellEdit(event: any): void {
    super.abortCellEdit(event)
    this.updateRepresentation()
  }

  onKeyupEnter(valid: boolean) {
    if (valid) {
      this.updateRepresentation()
      this.isEdited = false
      this.completeCellEdit.emit({ data: this.rowData, field: this.fieldName })
    }
  }

  updateRepresentation() {
    this.repr = StringUtils.currencyRepresentation(this.rowData[this.fieldName]?.currency)
    if (!!this.repr) this.repr += ' ' + this.currency
  }

  onDelete(): void {
    super.onDelete(() => (this.repr = ''))
  }

  triggerEdit() {
    setTimeout(() => {
      this.originalContent = { ...this.rowData[this.fieldName] }
      this.isEdited = true
    }, 0)
  }

  setValue(event: any) {
    if (this.rowData[this.fieldName]) {
      this.rowData[this.fieldName].currency = event
    } else {
      this.rowData[this.fieldName] = { currency: event }
    }
  }

  hasValue() {
    return !!this.rowData ? !!this.rowData[this.fieldName] : false
  }
}
